import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAddCircle$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAddCircle extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-plus", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M10 5.7085C10.4142 5.7085 10.75 6.04428 10.75 6.4585V9.25024H13.5418C13.956 9.25024 14.2918 9.58603 14.2918 10.0002C14.2918 10.4145 13.956 10.7502 13.5418 10.7502H10.75V13.5418C10.75 13.956 10.4142 14.2918 10 14.2918C9.58579 14.2918 9.25 13.956 9.25 13.5418V10.7502H6.4585C6.04428 10.7502 5.7085 10.4145 5.7085 10.0002C5.7085 9.58603 6.04428 9.25024 6.4585 9.25024H9.25V6.4585C9.25 6.04428 9.58579 5.7085 10 5.7085Z", fill: "currentColor" }), h("path", { d: "M1.5415 10.0003C1.5415 5.32892 5.32843 1.54199 9.99984 1.54199C14.6712 1.54199 18.4582 5.32892 18.4582 10.0003C18.4582 14.6717 14.6712 18.4587 9.99984 18.4587C5.32843 18.4587 1.5415 14.6717 1.5415 10.0003ZM9.99984 3.04199C6.15686 3.04199 3.0415 6.15734 3.0415 10.0003C3.0415 13.8433 6.15686 16.9587 9.99984 16.9587C13.8428 16.9587 16.9582 13.8433 16.9582 10.0003C16.9582 6.15734 13.8428 3.04199 9.99984 3.04199Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-add-circle-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-add-circle", "wpp-icon-add-circle-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-add-circle-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-add-circle-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAddCircle$1);
      }
      break;
  } });
}

const WppIconAddCircle = WppIconAddCircle$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAddCircle, defineCustomElement };
